import { createSelector } from '@reduxjs/toolkit';

import { selectActiveEpisodeId, selectPlayerProgress } from '@/store';

export const selectEpisodePlayerPosition = createSelector(
  [
    selectActiveEpisodeId,
    selectPlayerProgress,
    (state, episodeId) => episodeId,
  ],
  (activeEpisodeId, playerProgress, episodeId) => {
    const isEpisodeActive = activeEpisodeId === episodeId;
    return isEpisodeActive ? playerProgress.position : null;
  },
);
